// MESS-06, Betreiberfreigabe 27.10.2026: Herkunft nur im sessionStorage des Tabs, Erstkontakt gilt.
const SCHLUESSEL = "clartext_herkunft";
const UTM_FELDER = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];
const UTM_MUSTER = /^[A-Za-z0-9._-]{1,100}$/;
const GCLID_MUSTER = /^[A-Za-z0-9_-]{1,200}$/;

const gueltig = (wert, muster) => (typeof wert === "string" && muster.test(wert) ? wert : null);

export function leseHerkunft() {
  try {
    const wert = JSON.parse(window.sessionStorage.getItem(SCHLUESSEL));
    return wert && typeof wert === "object" ? wert : null;
  } catch {
    return null;
  }
}

export function erfasseHerkunft(search) {
  try {
    if (window.sessionStorage.getItem(SCHLUESSEL)) return;
    const params = new URLSearchParams(search || "");
    const herkunft = {};
    UTM_FELDER.forEach((feld) => { herkunft[feld] = gueltig(params.get(feld), UTM_MUSTER); });
    herkunft.gclid = gueltig(params.get("gclid"), GCLID_MUSTER);
    if (Object.values(herkunft).every((wert) => wert === null)) return;
    window.sessionStorage.setItem(SCHLUESSEL, JSON.stringify(herkunft));
  } catch {
    /* blockierter Speicher darf nie eine Seite oder Anfrage stören */
  }
}

export function mitHerkunft(body) {
  const herkunft = leseHerkunft();
  return herkunft ? { ...body, herkunft } : body;
}
